// Ported from planning/frontend/app/utilities/theme-options.ts — kept in sync
// with the :root[data-theme="..."] blocks in src/styles/theme.css.

export const THEME_OPTIONS = [
  { name: "signal-red", label: "Signal Red", mode: "dark", swatchBg: "#14100e", swatchAccent: "#d6543a" },
  { name: "ballpoint-blue", label: "Ballpoint Blue", mode: "dark", swatchBg: "#0f1216", swatchAccent: "#5b8dd6" },
  { name: "ledger-green", label: "Ledger Green", mode: "dark", swatchBg: "#0f1310", swatchAccent: "#6a9c5c" },
  { name: "royal-violet", label: "Royal Violet", mode: "dark", swatchBg: "#120f16", swatchAccent: "#8b6fd6" },
  { name: "sepia-brown", label: "Sepia Brown", mode: "dark", swatchBg: "#15110c", swatchAccent: "#a9803f" },
  { name: "graphite", label: "Graphite", mode: "dark", swatchBg: "#101012", swatchAccent: "#9aa3ad" },
  { name: "fountain-teal", label: "Fountain Teal", mode: "dark", swatchBg: "#0a1413", swatchAccent: "#3f9c94" },
  { name: "correction-rose", label: "Correction Rose", mode: "dark", swatchBg: "#150e11", swatchAccent: "#c9587a" },
  { name: "parchment", label: "Parchment", mode: "light", swatchBg: "#f2ead9", swatchAccent: "#8a4a2f" },
  { name: "chalk-slate", label: "Chalk Slate", mode: "light", swatchBg: "#eef1f0", swatchAccent: "#2f4f7a" },
  { name: "rice-paper", label: "Rice Paper", mode: "light", swatchBg: "#f5f3ea", swatchAccent: "#4f6a3f" },
];

export const isThemeName = (value) => THEME_OPTIONS.some((option) => option.name === value);

export const modeOf = (name) => THEME_OPTIONS.find((option) => option.name === name)?.mode ?? "dark";

export const DEFAULT_DARK_THEME = "signal-red";
export const DEFAULT_LIGHT_THEME = "parchment";
